import { render, staticRenderFns } from "./IconAttrWithDetail.vue?vue&type=template&id=8c80b882&scoped=true&"
import script from "./IconAttrWithDetail.vue?vue&type=script&lang=js&"
export * from "./IconAttrWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./IconAttrWithDetail.vue?vue&type=style&index=0&id=8c80b882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c80b882",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
